"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _bubbliesStrings = require("./bubbliesStrings");

var _bubbliesStrings2 = _interopRequireDefault(_bubbliesStrings);

var _propTypes = require("../propTypes");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bubblies = function Bubblies(props) {
  return _react2.default.createElement(
    "div",
    { "aria-hidden": "true" },
    _react2.default.createElement("svg", { style: { width: "100%" }, dangerouslySetInnerHTML: { __html: _bubbliesStrings2.default[props.type] }, version: "1.1", viewBox: "0 0 150 150", xmlns: "http://www.w3.org/2000/svg" })
  );
};

Bubblies.propTypes = {
  type: _propTypes2.default
};

Bubblies.defaultProps = {
  type: "default"
};

exports.default = Bubblies;